import {
  TableHeaderDefinitionCellType,
  TableCell,
} from '~/components/organism/Table/types';
import { BaseHeaderCellOptions } from '../asBaseCell';
import { asBaseOptions } from '../asBaseCell';

export type BooleanRenderFunction = (
  value: boolean,
  tableCell: TableCell<boolean>,
) => React.ReactNode;

type BooleanHeaderCellOptions = BaseHeaderCellOptions & {
  renderFunction?: BooleanRenderFunction;
};

const asBooleanTableHeaderCell = ({
  renderFunction,
  ...rest
}: BooleanHeaderCellOptions): TableHeaderDefinitionCellType<boolean> => {
  const renderFn =
    renderFunction == null
      ? (value: boolean) => value.toString()
      : renderFunction;

  const options = {
    ...asBaseOptions({ ...rest }),
    Cell: (tableCell: TableCell<boolean>) =>
      renderFn(tableCell.cell.value, tableCell),
  };

  return options;
};

export default asBooleanTableHeaderCell;
